import {useEffect, useState} from "react";


export default function useAdminHook(){
	let [search] = useState(new URLSearchParams(window.location.search));
	const [URLS,SETURLS] =  useState( {
		login : "https://auth.dice.tech/auth/admin/auth",
		otp : `https://auth.dice.tech/auth/admin/otp`,
		password: `https://auth.dice.tech/auth/admin/password`
	})
	useEffect(()=>{
		let origin = search.get("origin") || 'dice.tech'
		if(origin==="stage.adanionect.com" || origin==="stage.adanionect.comcorporate"){
			SETURLS({
				login : "https://stage.adanionect.com/api/cockpit/auth/auth",
				otp : `https://stage.adanionect.com/api/cockpit/auth/otp`,
				password: `https://stage.adanionect.com/api/cockpit/auth/password`
			})
		}
		if(origin==="adanionect.com" || origin==="www.adanionect.com"){
			SETURLS({
				login : "https://www.adanionect.com/api/cockpit/auth/auth",
				otp : `https://www.adanionect.com/api/cockpit/auth/otp`,
				password: `https://www.adanionect.com/api/cockpit/auth/password`
			})
		}
		if(origin==="ct-stage-finance.dice.tech"){
			SETURLS({
				login : "https://ooo-stage-api.dice.tech/cockpit/auth/auth",
				otp : `https://ooo-stage-api.dice.tech/cockpit/auth/otp`,
				password: `https://ooo-stage-api.dice.tech/cockpit/auth/password`
			})
		}
		if(origin==="ooo-finance.cleartrip.com"){
			SETURLS({
				login : "https://ooo-api.cleartrip.com/cockpit/auth/auth",
				otp : `https://ooo-api.cleartrip.com/cockpit/auth/otp`,
				password: `https://ooo-api.cleartrip.com/cockpit/auth/password`
			})
		}
	},[search])
	return URLS
}
